import { Component, OnInit, OnDestroy, OnChanges, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DadosContratosModel } from './../model/dados-contrato.model';
import { BehaviorSubject, Subscription } from 'rxjs';
import Utils from '../utils/utils';

@Component({
  selector: 'app-renova-contrato-amplo-pf',
  templateUrl: './renova-contrato-amplo-pf.component.html',
  styleUrls: ['./renova-contrato-amplo-pf.component.css']
})
export class RenovaContratoAmploPfComponent implements OnInit {

  @Input() infoContratos: DadosContratosModel;
  public inscricaoFormatada: string;


  ngOnInit(){
   // this.formatarInscricao();
   this.formataMascaraInscricao();
  }

  public formatarInscricao() {

    const tipoInsc = this.infoContratos.tipoInscricao;
    this.inscricaoFormatada = Utils.formatarInscricao(this.infoContratos.inscricao, tipoInsc);
    switch (tipoInsc) {
      case '3':
        this.inscricaoFormatada = Utils.mascararCPF(this.inscricaoFormatada);
        break;
      case '2':
        this.inscricaoFormatada = Utils.mascararCEI(this.inscricaoFormatada);
    }
  }

  public formataMascaraInscricao(){
    const tipoInsc = this.infoContratos.tipoInscricao;    
    this.inscricaoFormatada = Utils.mascararInscricao(tipoInsc, this.infoContratos.inscricao);
  }
}
